import React, { useEffect, useRef, useContext } from "react";
import {
  fixableWrapper, fixableContent,
  scrollFixed, scrollShow, fixableWrapperBestseller, fixableWrapperAnnouncBar,
  fixableWrapperHideHeaderBar
} from "./style.mod.scss";
import GlobalContext  from "services/global-context";

const FixableContent = ({ children, hideHeaderBar }) => {
  const _content = useRef(null);

  const { enabledAnnouncmenetBar, disableScrollableMenu } = useContext(GlobalContext);

  useEffect(() => {
    let lastScroll = 0;
    let scrollTimeout;
    const onScroll = () => {
      clearTimeout(scrollTimeout);

      if (window.scrollY < 100) return;

      const toggleMenu = (visible) => {
        const isVisible = Array.from(_content?.current?.classList)?.includes(scrollFixed);
        if (visible && !isVisible) {
          _content?.current?.classList.add(scrollShow);
          setTimeout(() => _content?.current?.classList.add(scrollFixed), 50);
        } else if (!visible && isVisible) {
          _content?.current?.classList.remove(scrollShow);
          setTimeout(() => _content?.current?.classList.remove(scrollFixed), 300);
        }
      };

      scrollTimeout = setTimeout(() => {
        const limit = Math.abs(lastScroll - window.scrollY);
        if (limit < 50) return;

        if (lastScroll < window.scrollY) toggleMenu(false);
        else toggleMenu(true);
        lastScroll = window.scrollY;
      }, 10);
    };

    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <div className={`${fixableWrapper} ${disableScrollableMenu && fixableWrapperBestseller} ${enabledAnnouncmenetBar && fixableWrapperAnnouncBar} ${hideHeaderBar && fixableWrapperHideHeaderBar}`}>
      <div className={fixableContent} ref={_content}>
        { children }
      </div>
    </div>
  );
};

export default FixableContent;
